import { getCategoriesToFillForScope } from '@/domain/external/utils/get-categories-to-fill-for-scope';
import { selectAllImpactCo2Answers } from '@/domain/impact-co2/impact-co2.selectors';
import { RootState } from '@/domain/store';

export const selectExternalInfos = (state: RootState) => {
  return state.external.infos;
};

export const selectUserHasStartedToFillForm = (state: RootState) => {
  const answers = selectAllImpactCo2Answers(state);
  const atLeastOneAnswer = answers.length > 0;
  return atLeastOneAnswer;
};

export const selectExternalFormCompletion = (state: RootState) => {
  const { scope } = selectExternalInfos(state);
  const answers = selectAllImpactCo2Answers(state);
  const categoryToFill = getCategoriesToFillForScope(scope);
  const categoryAnsweredCount = categoryToFill
    .map((categ) => answers.some((ans) => ans.category === categ))
    .filter((x) => x === true).length;
  const progression = categoryAnsweredCount / categoryToFill.length;
  return progression;
};
